<script>
  import { createEventDispatcher } from 'svelte'
  import { showModal } from '../stores.js'
  const dispatch = createEventDispatcher()
  const toggle = () => dispatch('toggle')

  // button 'on' property reacts to showModal to swap designs
  $: button = { on: $showModal }
  function handleClick() {
    toggle()
    button.on = !button.on
  }
</script>

{#if button.on}
  <p class="close" on:click={handleClick}>X</p>
{:else}
  <div class="cart" on:click={handleClick} />
{/if}

<style lang="scss">
  @import '../responsive.scss';

  .cart {
    margin-top: 14px;
    width: 30px;
    height: 30px;
    background-size: 30px;
    &:hover {
      background-position-y: 31px;
      cursor: pointer;
    }
    background-image: url('../images/shopping-cart.svg');

    @include for-phone {
      width: 20px;
      height: 20px;
      background-size: 20px;
      margin-top: 11px;
      &:hover {
        background-position-y: 20px;
      }
    }
  }
  .close {
    font-family: 'Arteria-Bold';
    font-size: 3rem;
    margin-top: 10px;
    color: var(--dark);
    cursor: pointer;
    &:hover {
      color: var(--red);
    }
    &::before {
      content: '[';
      font-feature-settings: 'case' 1;
    }
    &::after {
      content: ']';
      font-feature-settings: 'case' 1;
    }

    @include for-phone {
      font-size: 1.5rem;
      margin-top: 8px;
    }
  }
</style>
